import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import { LoadingState } from '../states/StateViews';

// Wraps student-only routes. Guests are redirected to /login and returned to the
// page they wanted after signing in.
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <section className="adaptive-page">
        <LoadingState label="Checking your session…" />
      </section>
    );
  }

  if (status === 'guest') {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" state={{ from }} replace />;
  }

  return <>{children}</>;
}
